/** The You sections: routes, nav labels and where legacy `/you#anchor` links now live. */
export const YOU_SECTIONS = [
  { id: 'account', label: 'Account', blurb: 'Email, invites, sign out' },
  { id: 'security', label: 'Security', blurb: 'Passkeys, trusted devices, app lock, recovery' },
  { id: 'machines', label: 'Machines', blurb: 'Status, load, doctor, branches' },
  { id: 'providers', label: 'Providers', blurb: 'Accounts, usage, cost' },
  { id: 'notifications', label: 'Notifications', blurb: 'Push, quiet hours, digests' },
  { id: 'appearance', label: 'Appearance', blurb: 'Theme' },
  { id: 'research', label: 'Research', blurb: 'Research library, voice mode' }, // g8-voice
  { id: 'advanced', label: 'Advanced', blurb: 'Automation grants, project autonomy' },
] as const

export type YouSectionId = (typeof YOU_SECTIONS)[number]['id']

/** Old single-page anchors (`/you#machines`) → the section that now holds them. */
export const LEGACY_ANCHORS: Record<string, YouSectionId> = {
  profile: 'account',
  invites: 'account',
  passkeys: 'security',
  devices: 'security',
  security: 'security',
  'recovery-keys': 'security',
  machines: 'machines',
  hygiene: 'machines',
  usage: 'providers',
  providers: 'providers',
  'usage-settings': 'providers',
  metrics: 'providers',
  notifications: 'notifications',
  appearance: 'appearance',
  automation: 'advanced',
  policies: 'advanced',
}

/** Where a legacy hash should land, or undefined when it is not one of ours. */
export function legacyTarget(hash: string): YouSectionId | undefined {
  return LEGACY_ANCHORS[hash.replace(/^#/, '')]
}
